import { Hidden } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useRouteMatch } from 'react-router-dom';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { GuidedProcessSupportBlock } from '../../../../../global/components/guided-process-support-block';
import { MainContent } from '../../../../../global/components/layout/main-content-container';
import { PageContainer } from '../../../../../global/components/layout/page-container';
import { PageHeader } from '../../../../../global/components/layout/page-header';
import { SideBarContent } from '../../../../../global/components/layout/sidebar-content';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';
import { useInstitutionSetting } from '../../../components/use-institution-settings';
import { ArcRoutes } from '../../../constants/routes';
import { GuidedProcessSupportProps } from '../../../models/arc-epi-props';
import { InstitutionState } from '../institution-model';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { ApiEndpoint } from '../../../../../global/constants/api-endpoints';
import { ReportAccessState } from '../../report/models/report-models';
import { getReportAccess } from '../../../../../global/ducks/report-prc-api';
import { setReportAccessRight } from '../../report/report-slices';
import { WysiwygWithReactLink } from '../../../../../global/components/wysiwyg-with-react-link';
import { DomoLink } from '../../../../../global/components/domo-report-link';


function ReportsInstitution() {
	const dispatch = useDispatch();
	const routeMatch = useRouteMatch();

	const institutionSetting = useInstitutionSetting();
	const epiProps = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const institutionSettingLoaded = epiProps.institutionSettingsState.contentLoaded;

	const gpsSettings = useSelector<TcsmStates, GuidedProcessSupportProps>(state => state.epiProps?.gpsSettingsState?.epiContent);

	const institutionState = useSelector<TcsmStates, InstitutionState>(state => state.institutionState);
	const institutionSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.InstitutionSearch}`);
	const reportAccessState = useSelector<TcsmStates, ReportAccessState>(state => state.reportAccessState);
	const institutionAccess = reportAccessState?.accessRights?.available_institutions?.find(a => a.client_number === institutionState?.institutionClientNumber);

	useEffect(() => {
		if (!reportAccessState.accessRightsLoaded) {
			dispatch(getReportAccess((res) => dispatch(setReportAccessRight(res?.data))));
		}

	}, []);

	if (!institutionState?.institutionClientNumber) {
		return (
			<Redirect to=
				{
					{
						pathname: institutionSelect,
						state: {
							actionLink: routeMatch.path,
						},
					}
				}
			/>);
	}



	if (!institutionSettingLoaded) {
		return <LoadingCircle />;
	}



	function RenderContent() {

		if (!institutionAccess) {
			return (
				<DividerSection removeDivider>
					<WysiwygWithReactLink content={institutionSetting?.reportNotAvailableMessage} />
				</DividerSection>
			);
		}

		return (
			<>
				<DividerSection removeDivider>
					{
						institutionAccess?.reports_access?.er_employee_pension_medial_enrollment &&
						<DomoLink linkText={institutionSetting?.erSummaryReportDownloadButtonText}
							domoLink={`${ApiEndpoint.domoUrl}report_name=EREmployeeDetailedReport-PensionandMedicalEnrollment&institution_client_number=${institutionState?.institutionClientNumber}`} />
					}
					{
						institutionAccess?.reports_access?.employee_list &&
						<DomoLink linkText={institutionSetting?.employeeListDownloadButtonText}
							domoLink={`${ApiEndpoint.domoUrl}report_name=EREmployeeList&institution_client_number=${institutionState?.institutionClientNumber}`} />

					}
				</DividerSection>
			</>
		);
	}

	return (
		<PageContainer>
			<MainContent>
				<PageHeader headerText={institutionSetting?.reportsInstitutionTitle} description={institutionSetting?.reportsInstitutionDescription} />
				<Hidden mdUp>
					<SideBarContent>
						<GuidedProcessSupportBlock title={gpsSettings?.institutionReportsGpsTitle} contents={gpsSettings?.institutionReportsGps} />
					</SideBarContent>
				</Hidden>
				<RenderContent />
			</MainContent>

			<Hidden smDown>
				<SideBarContent>
					<GuidedProcessSupportBlock title={gpsSettings?.institutionReportsGpsTitle} contents={gpsSettings?.institutionReportsGps} />
				</SideBarContent>
			</Hidden>
		</PageContainer>
	);
}

export default ReportsInstitution;